import React from "react";
import styles from "../_css/StaticContent.module.css";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ABOUT_SALAH_DATA, ABOUT_SALAH } from "../data/aboutSalah";
import { useSelector } from "react-redux";
import Header from "../_components/common/Header";

function TermsAndConditions() {
  const navigate = useNavigate();
  const lang = useSelector((state) => state.language.lang);
  const { title, about, name, lastName ,content} = ABOUT_SALAH_DATA[lang];

  return (
    <div className={styles.termsAndConditionsContainer}>
      <Header ispublic = {true} />
      <div className={styles.accountSettingsHeaderLeft}>
        <i className="cursor-pointer" onClick={() => navigate("/")}>
          <ArrowLeft size={16} />
        </i>
        <h5>{title}</h5>
      </div>
      <div
        style={{
          flexDirection: lang === "ar" ? "row-reverse" : "row",
        }}
        className={styles.aboutSalahCard}
      >
        <div
          className={`${styles.textSection} ${
            lang === "ar" ? styles.textSection : ""
          }` }
        >
          <h2 className={styles.titleHero} style={{textAlign: lang == "ar" && "left" }}>
            {content}
            <br />
            {/* {lastName} */}
          </h2>
        </div>
        <div
          style={{
            left: lang === "ar" ? "0" : "auto",
            right: lang === "ar" ? "auto" : "0",
          }}
          className={styles.imageSection}
        >
          {/* <img 
            src={`${process.env.REACT_APP_PROJECT_URL}/img/dr-salah-hero.jpg`} 
            alt="Salah Al Rashed" 
            className={`${styles.cardImage} ${styles.cardImageDesktop}`} 
          />
          <img 
            src={`${process.env.REACT_APP_PROJECT_URL}/img/askSalahLoginPage.jpg`} 
            alt="Salah Al Rashed" 
            className={`${styles.cardImage} ${styles.cardImageMobile}`} 
          /> */}
        </div>
      </div>
      <div className={styles.cardContainer}>
        <div className={styles.contentContainer}>
          {ABOUT_SALAH[lang].map((item, index) => (
            <div className={styles.contentItem} key={item.title}>
              <h5>
                {index + 1}. {item.title}
              </h5>
              {Array.isArray(item.content) ? (
                <ul style={{listStyle: item?.isSentence ? "none" : "disc", textIndent: item?.isSentence ? "0" : "1.5em"}}>
                  {item.content.map((el, index) => (
                    <li style={{textAlign:'justify'}} key={index}>{el}</li>
                  ))}
                </ul>
              ) : (
                <p>{item.content}</p>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default TermsAndConditions;
